import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section className="py-4" style={{ background: '#FAF6ED' }}>
      <div className="container">
        <div
          className="card border-0 shadow-sm rounded-4 p-4"
          style={{ background: '#fff' }}
        >
          <h1
            className="fw-bold mb-2"
            style={{
              fontFamily: "'Playfair Display', serif",
              color: '#2c2c2c',
              fontSize: '1.5rem',
            }}
          >
            Privacy Policy
          </h1>

          <p
            className="mb-3"
            style={{ fontSize: '.9rem', color: '#7a6a3a' }}
          >
            Effective Date: 01 January 2026
          </p>

          <p style={{ fontSize: '.96rem', color: '#4a3e19' }}>
            Zoteya Beauty Salon (“Zoteya Beauty”, “we”, “us”, or “our”)
            respects your privacy and is committed to protecting your personal
            information. This Privacy Policy explains how we collect, use,
            store, disclose, and safeguard your information when you visit our
            website, make a purchase, or use our services.
          </p>

          <p style={{ fontSize: '.96rem', color: '#4a3e19' }}>
            By accessing our website or engaging with our services, you consent
            to the practices described in this Privacy Policy.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            1. Information We Collect
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>
              Contact information: full name, email address, phone number,
              billing address, and delivery address.
            </li>
            <li>
              Order and transaction information: products or services
              purchased, order history, and payment method details (processed
              securely via third‑party providers; card details are not stored
              by us).
            </li>
            <li>
              Account information: login details and preferences, where an
              account is created.
            </li>
            <li>
              Communications: enquiries, bookings, customer support messages,
              feedback, and reviews.
            </li>
            <li>
              Technical and usage information: IP address, browser type,
              device details, and site usage collected via cookies and similar
              technologies.
            </li>
          </ul>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            2. How We Use Your Information
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>To process and fulfil orders, bookings, and payments.</li>
            <li>To communicate with you about purchases and enquiries.</li>
            <li>To provide customer support and respond to requests.</li>
            <li>
              To send marketing communications, promotions, or updates (you
              can opt out at any time).
            </li>
            <li>
              To improve our website, products, services, and overall customer
              experience.
            </li>
            <li>To comply with legal, regulatory, and contractual duties.</li>
          </ul>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            3. Sharing of Personal Information
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            We do not sell your personal information. We only share your data
            where necessary and lawful, including with:
          </p>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>
              Service providers such as payment processors, delivery and
              courier partners, booking systems, website hosting, and email
              platforms.
            </li>
            <li>
              Legal and regulatory authorities where required by law, court
              order, or regulation.
            </li>
            <li>
              Business partners in the event of a merger, sale, restructuring,
              or transfer of assets, where your information may form part of
              the business.
            </li>
          </ul>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            4. Your Rights
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            You may have the right to:
          </p>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Access and request correction of your personal data.</li>
            <li>Request deletion of your data or closure of your account.</li>
            <li>Opt out of marketing communications at any time.</li>
            <li>
              Withdraw consent for certain processing, where consent is the
              legal basis.
            </li>
          </ul>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            To exercise these rights, please contact us at{' '}
            <a href="mailto:lufunov@gmail.com">lufunov@gmail.com</a>.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            5. Data Retention
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            We retain personal information only for as long as necessary to
            fulfil the purposes described in this policy, unless a longer
            retention period is required or permitted by law.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            6. Cookies and Tracking Technologies
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            We use cookies and similar technologies to enhance functionality,
            analyse traffic, and improve user experience. You can adjust your
            browser settings to refuse cookies, but some features of the site
            may not function properly.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            7. Third‑Party Links
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Our website may contain links to third‑party websites. Zoteya
            Beauty is not responsible for the privacy practices or content of
            those sites. We encourage you to review their privacy policies
            before providing personal information.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            8. Security
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            We implement reasonable administrative, technical, and physical
            safeguards to protect your personal information from unauthorised
            access, loss, misuse, or disclosure. However, no method of online
            transmission or electronic storage is completely secure.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            9. Children’s Privacy
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Our services are not intended for individuals under the age of 18,
            and we do not knowingly collect personal information from minors.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            10. Changes to This Privacy Policy
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated effective date.
            Continued use of our website or services after changes are posted
            constitutes acceptance of the revised policy.
          </p>

          <h2
            className="mt-3"
            style={{ fontSize: '1.1rem', color: '#2c2c2c' }}
          >
            Contact Us
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            If you have any questions about this Privacy Policy or how your
            personal information is handled, please contact:
          </p>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Zoteya Group (Pty) Ltd
            <br />
            Email:{' '}
            <a href="mailto:lufunov@gmail.com">lufunov@gmail.com</a>
            <br />
            Address: 33 Wessel Street, Edenburg, Sandton, South Africa
          </p>

          <p
            className="mt-3"
            style={{ fontSize: '.9rem', color: '#7a6a3a' }}
          >
            This website was designed and developed by Webwizards Pty Ltd, a
            South African web development company.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
